import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import Timer from "@/components/clockWork/timer.vue";
import BaseMixer from "../../BaseMixer";
import Swal from "sweetalert2";
import { ILiveViewUserModeEntryDTO } from "@/store/models/workView/liveViewUserModeEntry";
let LiveViewUserEntryComponent = /** @class */ (() => {
    var _a;
    let LiveViewUserEntryComponent = class LiveViewUserEntryComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.showTimer = false;
        }
        workviewTooltip(value) {
            if (value != null) {
                return value.length > 23 ? value : null;
            }
        }
        created() {
            if (this.liveViewUserModeEntry.clockWorkEntryId != null) {
                this.showTimer = true;
            }
            else {
                this.liveViewUserModeEntry.totalTimeInSeconds = 0;
            }
        }
        destroyed() {
            clearInterval(this.interval);
        }
        get seconds() {
            return this.liveViewUserModeEntry.totalTimeInSeconds;
        }
        get clockWorkEntryId() {
            if (this.liveViewUserModeEntry.clockWorkEntryId != null) {
                this.showTimer = true;
                clearInterval(this.interval);
            }
            else {
                this.showTimer = false;
                clearInterval(this.interval);
            }
            return this.liveViewUserModeEntry.clockWorkEntryId;
        }
        goToProjectOverView(projectId, isViewable) {
            if (projectId != null) {
                if (isViewable) {
                    this.$router.push({ name: "ProjectOverview", params: { projectId: projectId } });
                }
                else {
                    Swal.fire({
                        text: "Sorry! You do not have access to view this Project.",
                        icon: "warning",
                        confirmButtonColor: "#34c38f",
                        confirmButtonText: "Okay",
                    }).then(() => { });
                }
            }
        }
        showProjectTitleMessage(projectCode, projectString) {
            if (projectString == "Unassigned" && projectCode == "") {
                return "";
            }
            else {
                return projectCode + " " + projectString;
            }
        }
        showTaskTitleMessage(taskCode, taskString) {
            if (taskString == "Unassigned" && taskCode == "") {
                return "";
            }
            else {
                return taskCode + " " + taskString;
            }
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof ILiveViewUserModeEntryDTO !== "undefined" && ILiveViewUserModeEntryDTO) === "function" ? _a : Object)
    ], LiveViewUserEntryComponent.prototype, "liveViewUserModeEntry", void 0);
    LiveViewUserEntryComponent = __decorate([
        Component({
            name: "LiveViewUserEntryComponent",
            components: {
                Timer,
            },
        })
    ], LiveViewUserEntryComponent);
    return LiveViewUserEntryComponent;
})();
export default LiveViewUserEntryComponent;
